import {
  EXTENSIONS_ACTION,
  MAIN_PROFILE_ACTION,
  SURVEY_ACTION,
  USER_SURVEY_ACTION
} from '../../../constants/actions'
import { mergeToNewObject } from '../../../util/object.helpers'
import { THIRD_PARTY_TOOLS_TYPE_FILTERS } from '../../../constants/extensions'
import { buildThirdPartyToolsData } from '../../../util/extensions/extensions.helpers'
import { LAD_SURVEY_IDS } from '../../../constants/survey'

export const extensionsProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case MAIN_PROFILE_ACTION.ON_LOAD_MAIN_DATA_SUCCESS:
      const thirdPartyTools =
        payload.surveys?.[LAD_SURVEY_IDS.THIRD_PARTY_TOOLS]?.questions?.en
          ?.questions
      return mergeToNewObject(
        state,
        { thirdPartyTools },
        handleToolsFilterChange(thirdPartyTools, state.toolsFilterType)
      )

    case EXTENSIONS_ACTION.CHANGE_TOOL_FILTER_STATE:
      return mergeToNewObject(state, {
        toolsFilterType: payload.value,
        ...handleToolsFilterChange(state.thirdPartyTools, payload.value)
      })

    case SURVEY_ACTION.ON_SUBMIT_USER_SURVEY:
    case SURVEY_ACTION.ON_UPDATE_USER_SURVEY:
      const { surveyId, questionId, liked } = payload
      const surveys = state.userSurveysLikesCount?.[surveyId]
      const likesCount = surveys?.[questionId] || 0
      return mergeToNewObject(state, {
        userSurveysLikesCount: {
          ...state.userSurveysLikesCount,
          [surveyId]: {
            ...surveys,
            [questionId]: liked
              ? likesCount + 1
              : likesCount > 0
              ? likesCount - 1
              : 0
          }
        }
      })

    case USER_SURVEY_ACTION.ON_GET_SURVEY_ANALYTICS_SUCCESS:
      return mergeToNewObject(state, { userSurveysLikesCount: payload })

    default:
      return state
  }
}

const INITIAL_STATE = {
  thirdPartyTools: [],
  filteredThirdPartyTools: [],
  toolsFilterType: THIRD_PARTY_TOOLS_TYPE_FILTERS.ALL,
  userSurveysLikesCount: {}
}

export const EXTENSIONS_PROFILE_DISPATCH = {
  TOOLS_FILTER_TYPE: 'toolsFilterType'
}

const handleToolsFilterChange = (thirdPartyTools, toolsFilterType) => {
  return {
    filteredThirdPartyTools: buildThirdPartyToolsData(
      thirdPartyTools,
      toolsFilterType
    )
  }
}
